<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from "@/utils/uiWrapper";
import FooterViewOld from "./Old/OldChildActivities.vue";
import NewFooterView from "./New/NewChildActivities.vue";

const current = useUiWrapper(FooterViewOld, NewFooterView);
</script>
